<template>
	<main class="main" id="main" v-bind:class="theme">
		<div class="section-report-bug" @click.prevent="reportProblem()"><button>Report bug<i class="fa-solid fa-bug" aria-hidden="true"></i></button></div>
		<PageLoader />
		<InfoModal />
		<MediaModal />
		<SocialModal />
		<Notification />
		<EditModal />
		<BlogModal />
		<ImportModal />
		<AIPopUp />
		<AIPopUpFields />
		<AIPopUpNodeData />
		<ACFDataPicker />
		<ReportProblemModal /> 
		<TagUsers /> 
		<HideComment />
		<MultiSelectNodeCategories />
		<AddNodeModal   v-if="getContentStrategy.isAdding"/>
        <ApproveNodeModal  v-if="getContentStrategy.isApproving"/>
        <EditNodeModal v-if="getContentStrategy.isEditing"  />
		<ApproveAllNodeMdal v-if="getContentStrategy.isApprovingAll" />
		<!--<KeywordPlannerModal v-if="getOpenKeywordPlanner" />-->
		<KeywordPlannerModal v-if="showKeywordPlanner" />

		<div v-if="getContentStrategy.isShowing" class="strategy-comment-wrap" 	:class="{'active': getContentStrategy.isCommenting && getTaggedUsers.modalIsOpen === false && getShowHideCommentModal === false}" >
			<CommentsList :key="this.reloadCommentlist"></CommentsList>
		</div>
		<GoogleModal v-if="getSocial.googleModalIsOpen" />
		<div class="contility">
			<img v-bind:src="contility" alt="the contility" title="The contility" />
		</div>

		<!-- end contility -->
		<div class="flex-container">
			<!-- GET SIDEBAR -->
			<div class="sidebar__wrapper" id="sidebarWrapper">
				<Sidebar @nodeSelectedInSearch="nodeSelectedInSearch" :clientSlug="clientSlug"></Sidebar>
				<!-- GET NODE OVERVIEW -->
				<router-view @nodeOverviewClosed="nodeOverviewClosed" name="nodeOverview"></router-view>
				<!-- GET ADD NODE FORM -->
				<router-view @nodeRemoved="removeNode" @treeSaved="treeSaved" name="addNodeForm"></router-view>
			</div>
			<div class="node-form-large-sections" 
			:class="{ 
				keywordPlannerOpen: getOpenKeywordPlanner, 
				blogOpen: getOpenBlogEditor, 
				blogOpenAddNodeForm: getOpenBlogEditorAddNodeForm, 
				commentsOpen: getOpenCommentPanel,
				'social--overview' :  getSocial.currentPageSectionThatIsOpen === 'overview' ? true : false, 
				'social--add-node-form' :  getSocial.currentPageSectionThatIsOpen === 'add-node-form' ? true : false 
				}"
			>
				<div>
					<KeywordPlanner v-if="getOpenKeywordPlanner" />
					<Blog  v-if="getOpenBlogEditor || getOpenBlogEditorAddNodeForm" />
					<Social v-if="getSocial.currentPageSectionThatIsOpen !== ''" />
				</div>
				<a class="close close-blog-overview" href="#" title="Close" @click.prevent="onCloseLargeSection()" v-if="getOpenBlogEditorAddNodeForm === false">
					<i class="fas fa-times"></i>
				</a>
			</div>
			<!-- end sidebar__wrapper -->
			<!-- MAIN CONTENT -->
			<div class="main-content" :class="{'content-list-open' : listClass }">
				<div class="container">
					<router-view :key="viewRefreshKey" :clientSlug="clientSlug" @editNode="selectNode" @collapseSidebar="collapseSidebar" v-slot="{Component}">
						<component ref="clientView" :is="Component" />
					</router-view>
				</div>
				<!-- end container -->
			</div>
			<!-- end main-content -->
		</div>
		<!-- end flex-container -->
	</main>
</template>

<script>
import Sidebar from "./../components/sidebar/Sidebar.vue";
import PageLoader from "./../components/loader/PageLoader.vue";
import KeywordPlanner from "./../components/section/KeywordPlanner.vue";
import KeywordPlannerModal from "./../components/content-strategy/KeywordPlannerModal.vue";
import Blog from "./../components/section/Blog.vue";
import Social from "../components/section/Social/Social.vue";
import InfoModal from "./../components/tools/InfoModal.vue";
import MediaModal from "../components/tools/media/MediaModal.vue";
import SocialModal from './../components/tools/SocialModal.vue';
import {mapGetters} from "vuex"
import Notification from './../components/tools/Notification.vue';
import EditModal from './../components/tools/EditModal.vue';
import BlogModal from './../components/tools/BlogModal.vue';
import ImportModal from './../components/tools/ImportModal.vue';
import GoogleModal from './../components/tools/GoogleModal.vue';
import AIPopUp from './../components/tools/AIPopUp.vue';
import AIPopUpNodeData from './../components/tools/AIPopUpNodeData.vue';
import AIPopUpFields from './../components/tools/AIPopUpFields.vue';
import ACFDataPicker from './../components/tools/ACFDataPicker.vue';
import ReportProblemModal from './../components/tools/ReportProblemModal.vue';
import TagUsers from './../components/tools/TagUsers.vue';
import MultiSelectNodeCategories from './../components/tools/MultiSelectNodeCategories.vue';
import html2canvas from 'html2canvas';
import AddNodeModal from '../components/content-strategy/addNodeModal.vue';
import ApproveNodeModal from '../components/content-strategy/approveNodeModal.vue';
import EditNodeModal from '../components/content-strategy/editNodeModal.vue';
import CommentsList from '../components/lists/CommentsList.vue';
import ApproveAllNodeMdal from '../components/content-strategy/approveAllNodesModal.vue'
import HideComment from '../components/tools/HideComment.vue';
export default {
	data() {
		return {
			theme: "dashboard client has-sidebar blue-bg",
			contility: require("./../assets/img/contility.svg"),
			clientSlug: this.$route.params.client,
			viewRefreshKey: 0,
			listClass: '',
			showContentStrategyModal: false,
			reloadCommentlist: 0,
			showKeywordPlanner: false,
		}
	},
	async beforeMount(){
		try{
			await this.$store.dispatch('client/socialInit', this.clientSlug);
		}catch(error){
			console.log(error);
		}
	},
	mounted(){
		// Access the route name and assign it to a variable
		const routeName = this.$route.name;
		console.log('Current Route Name:', routeName);

		// Split the theme string into an array of classes
		let classes = this.theme.split(' ');

		// Remove the sidebar-open and sidebar-closed classes if they exist
		classes = classes.filter(c => c !== 'sidebar-open' && c !== 'sidebar-closed');

		// Append the new class based on the val parameter
		classes.push(this.getSidebarOpenState ? 'sidebar-open' : 'sidebar-closed');

		classes.push(this.getContentStrategy.isShowing ? 'content-strategy-showing' : ' ');

		// Join the array back into a string and assign it to this.theme
		this.theme = classes.join(' ');

		// 🔹 Apply URL params to state on load
		this.syncCommentStateFromUrl();
	},
	computed:{
		...mapGetters("client", ["getTaggedUsers", "getShowHideCommentModal", "getClientSlug", "getContentStrategy", "getOpenKeywordPlanner", "getOpenKeywordPlannerModal", "getOpenBlogEditor", "getOpenBlogEditorAddNodeForm", "getOpenCommentPanel", "getSocial", "getListView"]),
		...mapGetters("tools", ["getInfoModal"]),
		...mapGetters("views", ["getSidebarOpenState"]),
		...mapGetters("auth", ["getAuthUsername"]),
	},
	watch:{
		// 'getTaggedUsers.modalIsOpen': {
		// 	async handler(val) {
		// 		console.log('getTaggedUsers.modalIsOpen:', {val: val, conditon: this.getContentStrategy.isCommenting && this.getTaggedUsers.modalIsOpen === false});
		// 	},
		// },
		'getContentStrategy.isShowing': {
		async handler(val) {
			if (val === true) {
				this.theme = `${this.theme} content-strategy-showing`;
			} else {
				if (this.theme.includes('content-strategy-showing')) {
					// remove the 'content-strategy-showing' class from the theme
					this.theme = this.theme.replace('content-strategy-showing', '').trim();
				}
			}
		},
		deep: true
		},

		// 🔹 Keep URL in sync with comment panel state + node id
		'getContentStrategy.isCommenting': {
			async handler(val) {
				// Theme toggle
				if (val === true) {
					this.theme = `${this.theme} content-strategy-showing`;
				} else if (this.theme.includes('content-strategy-showing')) {
					this.theme = this.theme.replace('content-strategy-showing', '').trim();
				}

				const query = { ...this.$route.query };

				if (val) {
					query.isCommenting = 'true';
					const id = this.getCommentingNodeId();
					if (id) query.nodeId = String(id);
				} else {
					delete query.isCommenting;
					delete query.nodeId;
				}

				this.$router.replace({ path: this.$route.path, query }).catch(() => {});
			},
			deep: true
		},

		// 🔁 If nodes change while commenting is open, keep nodeId fresh
		getContentStrategy: {
			deep: true,
			handler() {
				if (!this.getContentStrategy?.isCommenting) return;
				const id = this.getCommentingNodeId();
				const query = { ...this.$route.query, isCommenting: 'true' };
				if (id && query.nodeId !== String(id)) {
					query.nodeId = String(id);
					this.$router.replace({ path: this.$route.path, query }).catch(() => {});
				}
			}
		},

		// 🔄 When the route changes (e.g., user pastes a URL), apply params to state
		$route() {
			this.syncCommentStateFromUrl();
		},

		'getSidebarOpenState' : function(val){
			//append to the class theme
			let classes = this.theme.split(' ');
			classes = classes.filter(c => c !== 'sidebar-open' && c !== 'sidebar-closed');
			classes.push(val ? 'sidebar-open' : 'sidebar-closed');
			this.theme = classes.join(' ');
		},
		'getOpenBlogEditor': function(val){
			console.log('getOpenBlogEditor watcher', val)
		},
		'getOpenBlogEditorAddNodeForm': function(val){
			console.log('getOpenBlogEditorAddNodeForm watcher', val)
		},
		'getOpenKeywordPlannerModal': function(val){
			console.log('getOpenKeywordPlannerModal watcher', val);
			this.showKeywordPlanner = val;
		},
		"getInfoModal.currentStep": function (newVal, oldVal) {
			console.log('the changed slide:', [newVal, oldVal])
		},
		"getCurrentNode": function (){
			const url = new URL(window.location.href);
			//if user was inside of the node, then open the node and go to the editor. 
			if(url.searchParams.get('node-editor') === 'true'){
				console.log('closing the sidebar contentmaster mounted in client');
				this.$store.commit('views/closeSidebar');
				this.$store.commit('client/setListView', true)
			}else{
				this.$store.commit('client/setListView', false);
			}

			// While commenting, keep nodeId synced when "current node" changes
			if (this.getContentStrategy?.isCommenting) {
				const id = this.getCommentingNodeId();
				const query = { ...this.$route.query, isCommenting: 'true' };
				if (id) {
					query.nodeId = String(id);
					this.$router.replace({ path: this.$route.path, query }).catch(() => {});
				}
			}
		},
		getListView(val){
			this.listClass = val;
			console.log('get list view!', val);
			let classes = this.theme.split(' ');
			classes = classes.filter(c => c !== 'list-view-open' && c !== 'list-view-close');
			classes.push(val ? 'list-view-open' : 'list-view-close');
			this.theme = classes.join(' ');
			console.log('get list viewclasses4!', this.theme);
		},
	},
	methods: {
		onCloseLargeSection(){
			this.$store.commit("client/setOpenKeywordPlanner", false);
			this.$store.commit("client/setOpenKeywordPlannerModal", false);
			this.$store.commit("client/setOpenBlogEditor", false);
			this.$store.commit("client/setOpenBlogEditorAddNodeForm", false);
			this.$store.commit("client/setOpenCommentPanel", false);
			this.$store.commit("client/setSocial", {prop: 'currentPageSectionThatIsOpen', val: ''});
		},
		nodeSelectedInSearch() {
			if(this.$refs){
				if(this.$refs.clientView && this.$refs.clientView.$.ctx && typeof this.$refs.clientView.$.ctx.centerOnNode === 'function'){
					this.$refs.clientView.$.ctx.centerOnNode()
				}
			}
		},
		async removeNode() {
			await this.$store.dispatch("client/removeNode")
			++this.viewRefreshKey
		},
		async treeSaved() {
			await this.$store.dispatch("client/saveClientContentTree")
            ++this.viewRefreshKey
		},
		reRenderContentTree() {
			++this.viewRefreshKey
		},
		checkSocialAuthCookie () {
			const cookies = document.cookie.split(';');
			for (const cookie of cookies) {
				if (cookie.trim().startsWith('social_auth=')) {
					return cookie.split('=')[1] === 'true';
				}
			}
			return false;
		},

		// 🔎 Resolve the node id to reflect in the URL while commenting
		getCommentingNodeId() {
			const nodes = this.getContentStrategy?.nodes || [];

			// If URL already has a valid nodeId, keep it
			const urlId = this.$route.query?.nodeId;
			if (urlId && nodes.some(n => String(n.id) === String(urlId))) {
				return String(urlId);
			}

			// Try common flags your UI might set on the active row
			const flagged =
				nodes.find(n => n.isCommenting) ||
				nodes.find(n => n.commenting) ||
				nodes.find(n => n.isSelected) ||
				nodes.find(n => n.selected) ||
				nodes.find(n => n.isOpen) ||
				nodes.find(n => n.isEditing);

			if (flagged?.id) return String(flagged.id);

			// If only one node is visible, assume it's the one
			if (nodes.length === 1 && nodes[0]?.id) {
				return String(nodes[0].id);
			}

			// No safe guess
			return null;
		},

		// 🔸 Read URL and set Vuex state so the panel opens/closes automatically
		syncCommentStateFromUrl() {
			const isCommentingParam = String(this.$route.query?.isCommenting || '').toLowerCase();
			const shouldOpen = isCommentingParam === 'true';

			// Only commit if state differs, to avoid loops
			if (Boolean(this.getContentStrategy?.isCommenting) !== shouldOpen) {
				// Adjust this mutation name if your store differs
				this.$store.commit('client/setContentStrategy', { prop: 'isCommenting', val: shouldOpen });
			}

			// If we opened and a nodeId exists, ensure URL stays consistent (no-op if same)
			if (shouldOpen) {
				const id = this.getCommentingNodeId();
				const query = { ...this.$route.query, isCommenting: 'true' };
				if (id) query.nodeId = String(id);
				this.$router.replace({ path: this.$route.path, query }).catch(() => {});
			}
		},

		async reportProblem() {
            try {
				document.querySelector('.main-content').classList.add('lock-section');
				document.querySelector('.section-report-bug').classList.add('lock-section');
				document.querySelector('.sidebar').classList.add('lock-section');
                const canvas = await html2canvas(document.querySelector('body'), { 
                    windowWidth: window.innerWidth, 
                    windowHeight: window.innerHeight,
                    x: window.pageXOffset,
                    y: window.pageYOffset
                });
                canvas.toBlob((blob) => {
                    this.$store.commit('client/setReportProblem', {prop: 'screenshot', val: blob});
                    this.$store.commit('client/setReportProblem', {prop: 'modalOpen', val: true});
                });
            } catch (error) {
                console.error('Error capturing screenshot:', error);
            }
        }
	},
	components: {
		Sidebar,
		PageLoader,
		KeywordPlanner,
		KeywordPlannerModal,
		Blog,
		InfoModal,
		MediaModal,
		Social,
		SocialModal,
		Notification,
		EditModal,
		BlogModal,
		GoogleModal,
		AIPopUp,
		AIPopUpNodeData,
		AIPopUpFields,
		ImportModal,
		ACFDataPicker,
		ReportProblemModal,
		TagUsers,
		MultiSelectNodeCategories,
		AddNodeModal,
		ApproveNodeModal,
		EditNodeModal,
		CommentsList,
		ApproveAllNodeMdal,
		HideComment
	},
}
</script>
<style lang="scss">
@import "./src/assets/scss/dashboard.scss";

.strategy-comment-wrap{
	z-index: 999;
    position: absolute;
    top: 0;
    right: 0;
}
</style>
